export default [
  {
    path: "/organizations/:organizationId/reports",
    props: true,
    component: () => import("@/views/reports/report/ListReports.vue"),
    meta: {
      authorization: {
        features: ["reports"],
        roles: ["organization-administrator", "report-summary", "report-viewer", "report-commenter", "report-creator"],
      },
    },
  },
  {
    path: "/organizations/:organizationId/reports/create",
    props: true,
    component: () => import("@/views/reports/report/CreateReport.vue"),
    meta: {
      authorization: {
        features: ["reports"],
        roles: ["organization-administrator", "report-creator"],
      },
    },
  },
  {
    path: "/organizations/:organizationId/reports/:reportId/start",
    name: "organization-reports-start",
    props: true,
    component: () => import("@/views/reports/report/StartReport.vue"),
    meta: {
      authorization: {
        features: ["reports"],
        roles: ["organization-administrator", "report-creator"],
      },
    },
  },
  {
    path: "/organizations/:organizationId/reports/bulkresults",
    name: "bulk-organization-reports",
    props: true,
    component: () => import("@/views/reports/report/BulkResultsReport.vue"),
    meta: {
      authorization: {
        features: ["reports"],
        roles: ["organization-administrator", "report-creator"],
      },
    },
  },
  {
    path: "/organizations/:organizationId/reports/:reportId",
    props: true,
    component: () => import("@/views/reports/report/EditReport.vue"),
    meta: {
      authorization: {
        features: ["reports", "investigations"],
        roles: [
          "organization-administrator",
          "report-creator",
          "report-viewer",
          "report-commenter",
          "report-editor-hire",
          "report-editor-answers",
          "investigation-creator",
          "investigation-viewer",
        ],
      },
    },
  },
  {
    path: "/organizations/:organizationId/reports/:reportId/export",
    component: () => import("@/views/reports/report/export-report/Export.vue"),
    meta: {
      authorization: {
        features: ["reports", "investigations"],
        roles: [
          "organization-administrator",
          "report-creator",
          "report-viewer",
          "report-commenter",
          "report-editor-hire",
          "report-editor-answers",
          "investigation-creator",
          "investigation-viewer",
        ],
      },
    },
    children: [
      {
        path: "page-1",
        props: true,
        component: () => import("@/views/reports/report/export-report/Page1.vue"),
        meta: {
          authorization: {
            features: ["reports", "investigations"],
            roles: [
              "organization-administrator",
              "report-creator",
              "report-viewer",
              "report-commenter",
              "report-editor-hire",
              "report-editor-answers",
              "investigation-creator",
              "investigation-viewer",
            ],
          },
        },
      },
      {
        path: "page-2",
        props: true,
        component: () => import("@/views/reports/report/export-report/Page2.vue"),
        meta: {
          authorization: {
            features: ["reports", "investigations"],
            roles: [
              "organization-administrator",
              "report-creator",
              "report-viewer",
              "report-commenter",
              "report-editor-hire",
              "report-editor-answers",
              "investigation-creator",
              "investigation-viewer",
            ],
          },
        },
      },
      {
        path: "page-3",
        props: true,
        component: () => import("@/views/reports/report/export-report/Page3.vue"),
        meta: {
          authorization: {
            features: ["reports", "investigations"],
            roles: [
              "organization-administrator",
              "report-creator",
              "report-viewer",
              "report-commenter",
              "report-editor-hire",
              "report-editor-answers",
              "investigation-creator",
              "investigation-viewer",
            ],
          },
        },
      },
      {
        path: "page-4",
        props: true,
        component: () => import("@/views/reports/report/export-report/Page4.vue"),
        meta: {
          authorization: {
            features: ["reports", "investigations"],
            roles: [
              "organization-administrator",
              "report-creator",
              "report-viewer",
              "report-commenter",
              "report-editor-hire",
              "report-editor-answers",
              "investigation-creator",
              "investigation-viewer",
            ],
          },
        },
      },
      {
        path: "page-5",
        props: true,
        component: () => import("@/views/reports/report/export-report/Page5.vue"),
        meta: {
          authorization: {
            features: ["reports", "investigations"],
            roles: [
              "organization-administrator",
              "report-creator",
              "report-viewer",
              "report-commenter",
              "report-editor-hire",
              "report-editor-answers",
              "investigation-creator",
              "investigation-viewer",
            ],
          },
        },
      },
      {
        path: "page-6",
        props: true,
        component: () => import("@/views/reports/report/export-report/Page6.vue"),
        meta: {
          authorization: {
            features: ["reports", "investigations"],
            roles: [
              "organization-administrator",
              "report-creator",
              "report-viewer",
              "report-commenter",
              "report-editor-hire",
              "report-editor-answers",
              "investigation-creator",
              "investigation-viewer",
            ],
          },
        },
      },
      {
        path: "page-7",
        props: true,
        component: () => import("@/views/reports/report/export-report/Page7.vue"),
        meta: {
          authorization: {
            features: ["reports", "investigations"],
            roles: [
              "organization-administrator",
              "report-creator",
              "report-viewer",
              "report-commenter",
              "report-editor-hire",
              "report-editor-answers",
              "investigation-creator",
              "investigation-viewer",
            ],
          },
        },
      },
    ],
  },
];
